<template>
  <div class="home">
    <div style="top:10px;position:absolute;left:10px;">
      <el-button type="primary" @click="back" plain>后退</el-button>
    </div>
    <div class="content">
      <el-row :gutter="12">
        <el-col :span="24">
          <el-button size="medium" @click="typeClick('/oee/mm/sc')">安全日历</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="24">
          <el-button size="medium" @click="typeClick('/oee/mm/qc')">质量日历</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="24">
          <el-button size="medium" @click="typeClick('/oee/weekCategory')">一周KPI总览</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="24">
          <el-button size="medium" @click="typeClick('/oee/weektracking_output')">每日生产跟踪</el-button>
        </el-col>
      </el-row>
      <el-row :gutter="12">
        <el-col :span="24">
          <el-button size="medium" @click="typeClick('/oee/weektracking_list')">运营会议</el-button>
        </el-col>
      </el-row>
    </div>


  </div>
</template>
<script>
  import router from "../../../../router";

  export default {
    name: 'home',
    data(){

      return {

      };
    },
    mounted() {
    },

    methods: {
      back() {
        router.back();
      },
      typeClick(data) {
        this.$router.push({
          path: data
        });
      },

    },
  }
</script>
<style scoped src='./category.css'></style>



// WEBPACK FOOTER //
// src/pages/oee/mm/category/category.vue